document.addEventListener("DOMContentLoaded", () => {
  const isDesktop = () => {
    return window.innerWidth >= 952;
  };

  const headerContainer = document.querySelector("#header");
  const navContainer = document.querySelector("#navbar-collapse");
  if (headerContainer && navContainer) {
    navContainer.addEventListener("mouseenter", (e) => {
      if (isDesktop()) {
        headerContainer.classList.add("hovered");
      }
    });

    navContainer.addEventListener("mouseleave", (e) => {
      if (isDesktop()) {
        headerContainer.classList.remove("hovered");
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const parentElements = document.querySelectorAll(".dropdown-parent");

  parentElements.forEach((element) => {
    element.addEventListener("mouseover", () => {
      element.classList.add("is-visible");
    });

    element.addEventListener("mouseout", () => {
      if (!element.matches(":hover")) {
        element.classList.remove("is-visible");
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const drawerElements = document.querySelectorAll(".drawer-go-to-lvl-1");
  const drawerLvl1Elements = document.querySelectorAll(".drawer-go-to-lvl-2");
  const elementsLvl1 = document.querySelectorAll(".dropdown-menu-lvl-1");
  const elementsLvl2 = document.querySelectorAll(".dropdown-menu-lvl-2");

  if (drawerElements) {
    drawerElements.forEach((element) => {
      const lvl1Element = element.querySelector(".dropdown-menu-lvl-1");
      if (!lvl1Element) return;

      element.addEventListener("click", () => {
        lvl1Element.classList.add("open");
      });
    });
  }

  if (drawerLvl1Elements) {
    drawerLvl1Elements.forEach((element) => {
      const lvl2Element = element.querySelector(".dropdown-menu-lvl-2");
      if (!lvl2Element) return;

      element.addEventListener("click", () => {
        lvl2Element.classList.add("open");
      });
    });
  }

  if (elementsLvl1) {
    elementsLvl1.forEach((el) => {
      const closeBtn = el.querySelector(".close-element-lvl-1");
      if (!closeBtn) return;
      closeBtn.addEventListener("click", () => {
        setTimeout(() => {
          el.classList.remove("open");
        }, 0);
      });
    });
  }

  if (elementsLvl2) {
    elementsLvl2.forEach((el) => {
      const closeBtn = el.querySelector(".close-element-lvl-2");
      if (!closeBtn) return;
      closeBtn.addEventListener("click", () => {
        setTimeout(() => {
          el.classList.remove("open");
        }, 0);
      });
    });
  }
});
